import { useTranslation } from "react-i18next";

import { Layer } from "types/types";

import GroupLayerDownload from "./download/GroupLayerDownload";
import SingleWMSLayerDownload from "./download/SingleWMSLayerDownload";
import { VectorLayerDownload } from "./download/VectorLayerDownload";
import { LayerSetAccordion } from "./LayerSetAccordion";

interface Props {
  selectedLayer: Layer;
}

export function LayerSetDownloadAccordion(props: Props) {
  const { t } = useTranslation();
  const { selectedLayer } = props;

  return (
    <LayerSetAccordion title={t("label.download")}>
      {selectedLayer.type === "WFS" && (
        <VectorLayerDownload layer={selectedLayer} />
      )}
      {selectedLayer.type === "WMS" && (
        <SingleWMSLayerDownload layer={selectedLayer} />
      )}

      {selectedLayer.type === "LAYERGROUP" && (
        <GroupLayerDownload subLayerList={selectedLayer.subLayerList} />
      )}
    </LayerSetAccordion>
  );
}
